<template>
  
  <div :id="_uid" class="ui large modal" :class="modalSelector">

    <div class="ui header">
      Selecionar Ficha Cadastral
    </div>

    <div class="content modal-content-scrolling">

      <div class="ui form">
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Número da Ficha</label>
            <input type="text" v-model="filter.registrationId" @input="onSearch">
          </div>
          <div class="five wide field">
            <label class="form-label">Animal</label>
            <input type="text" v-model="filter.animalName" @input="onSearch">
          </div>
          <div class="seven wide field">
            <label class="form-label">Tutor</label>
            <input type="text" v-model="filter.ownerName" @input="onSearch">
          </div>          
        </div>        
      </div>

      <p v-if="registrations && registrations.length == 0" class="grey text m-t-15 animated fadeIn">
        <i class="info circle icon"></i> Nenhuma ficha da clínica <strong>{{ customer ? customer.shortName : "" }}</strong> foi encontrada
      </p>

      <div v-if="registrations && registrations.length > 0" class="animated fadeIn">

        <p class="grey text m-t-20">
          <i class="info circle icon"></i> Fichas da clínica <strong>{{ customer ? customer.shortName : "" }}</strong>
        </p>

        <div class="ui basic segment no-padding no-margin" :class="{ loading }">                
          <table class="ui celled selectable tablet stackable table">
            <thead v-if="$isDesktop">
              <tr>
                <th>Número</th>
                <th>Animal</th>
                <th>Tutor</th>
              </tr>            
            </thead>
            <tbody>
              <tr v-for="registration in registrations" :key="registration.id" :class="{ 'disabled-row': isAnimalDead(registration) }" 
                @click="onSelectRegistration(registration)">                            
                <td>
                  <strong class="mobile-only">Número: </strong>
                  {{ registration.registrationId }}
                </td>
                <td>
                  <strong class="mobile-only">Animal: </strong>
                  <span v-html="renderAnimal(registration)"></span>
                </td>
                <td>
                  <strong class="mobile-only">Tutor: </strong>
                  <span v-html="renderOwner(registration)"></span>
                </td>
              </tr>            
            </tbody>
          </table>
        </div>

      </div>    

      <div v-if="others && others.length > 0" class="m-t-30">
        <a class="clickable" @click="showOthers = true">
          {{ others.length == 1 ? 'Foi encontrada uma ficha de outra clínica' : 'Foram encontradas ' + others.length + ' fichas de outras clínicas' }}
        </a>                
        <table v-if="showOthers" class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Clínica</th>
              <th>Número</th>
              <th>Animal</th>
              <th>Tutor</th>              
            </tr>            
          </thead>
          <tbody>
            <tr v-for="registration in others" :key="registration.id" :class="{ 'disabled-row': isAnimalDead(registration) }">                            
              <td>
                <strong class="mobile-only">Clínica: </strong>
                {{ registration.customer.shortName }}
              </td>
              <td>
                <strong class="mobile-only">Número: </strong>
                {{ registration.registrationId }}
              </td>
              <td>
                <strong class="mobile-only">Animal: </strong>
                <span v-html="renderAnimal(registration)"></span>
              </td>
              <td>
                <strong class="mobile-only">Tutor: </strong>
                <span v-html="renderOwner(registration)"></span>
              </td>
            </tr>            
          </tbody>
        </table>
      </div>        

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Cancelar
      </button>      
    </div>

  </div>

</template>

<script>

  import debounce from "debounce"
  import AnimalRegistrationService from "@/services/animal-registration-service"
  import modalDialog from "@/mixins/modal-dialog"

  export default {
    
    name: "AnimalRegistrationPicker",

    mixins: [modalDialog],

    data() {
      return {
        autofocus: true,
        registrations: null,
        others: null,
        showOthers: false,
        filter: {},
        service: new AnimalRegistrationService(),
      }
    },

    props: ["customer"],

    methods: { 
      
      onShow() {
        this.registrations = null
        this.filter = {}
      },

      onSearch: debounce(async function() {        

        if (this.isEmptyFilter())
          return

        this.loading = true
        this.showOthers = false

        try {          

          let registrations = []
          let others = []
          
          const data = await this.service.filter(this.filter)

          for (let registration of data) {
            if (registration.customerId == this.customer.id) {
              registrations.push(registration)
            } else {
              others.push(registration)
            }
          }

          this.registrations = registrations
          this.others = others
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }

      }, 1000),

      isEmptyFilter() {

        let isEmpty = true
        const { registrationId, animalName, ownerName } = this.filter

        if (registrationId || animalName || ownerName)
          isEmpty = false

        return isEmpty
      },

      renderAnimal(registration) {

        if (!registration || !registration.animal)
          return ""

        const animal = registration.animal
        const race = animal.race
        const species = race.species
        const raceLabel = `<div class="ui small label">${race.name}<div class="detail">Espécie ${species.name}</div></div>`
        const deadIcon = animal.dead ? '<i class="cross grey icon m-l-5"></i>' : ""        

        let sexIcon = animal.sex == "male" ? "mars blue icon" : "venus pink icon"

        if (animal.sex == "undefined")
          sexIcon = "question circle grey icon"

        return `<i class="${sexIcon}"></i> ${animal.name} ${raceLabel} ${deadIcon}`
      },

      renderOwner(registration) {

        if (!registration || !registration.owner)
          return ""

        return registration.owner.name  
      },

      isAnimalDead(registration) {

        let isDead = false

        if (registration && registration.animal)
          isDead = registration.animal.dead

        return isDead
      },

      onSelectRegistration(registration) {

        if (this.isAnimalDead(registration)) {
          this.$msg.info("Esse animal não pode ser selecionado porque já foi a óbito ... :(")
          return          
        }  

        this.emitEvent = { event: "onPick", data: registration }        
        this.hide()
      },
    },
  }

</script>